<template>
  <div class="service">
    <div class="fz14 bold fr ac jsb">
      <span>服务订单</span>
<!--      <el-button type="text" v-if="hasPermission(840)" @click="go('/releaseservice')">申请服务</el-button>-->
      <el-button type="text" v-if="hasPermission(840)" @click="applyShow = true">申请服务</el-button>
    </div>

    <div class="mt30">
      <el-tabs v-model="tab">
        <el-tab-pane label="所有订单" name=""></el-tab-pane>
        <el-tab-pane label="待确认" name="1"></el-tab-pane>
        <el-tab-pane label="待完成" name="3"></el-tab-pane>
        <el-tab-pane label="待评价" name="5"></el-tab-pane>
        <el-tab-pane label="已完成" name="6"></el-tab-pane>
      </el-tabs>

      <!-- 搜索 -->

      <div>
        <el-input style="width: 336px" placeholder="请输入订单号搜索" size="mini"></el-input>

        <el-button class="ml20" type="primary" size="mini">搜索</el-button>
      </div>

      <div class="info_box">
        <div class="fr ac fz12 mt30">
          <div class="center order_list_item">产品信息</div>
          <div class="center order_list_item">状态</div>
          <div class="center order_list_item">日期</div>
          <div class="center order_list_item">价格</div>
          <div class="center fg">操作</div>
        </div>

        <el-divider/>

        <!--        列表-->

        <div class="order-list fz12">
          <div class="order-item mt20" v-for="(item,index) in service_list" :key="index">
            <!--                上-->
            <div class="top fr ac jsb">
              <p class="ml10">订单号:{{ item.order_no }}</p>
            </div>
            <!--                中-->

            <div class="fr middle">
              <!-- 商品信息 -->
              <div class="order">
                <div class="fr order_left">
                  <div class="fr ac jc order_list_item">
                    <p class>【{{ item.type_name }}/{{ item.level_name }}】</p>
                  </div>
                  <div class="center order_list_item">{{ service_state_decide(item) }}</div>
                  <div class="center order_list_item">{{ item.create_time }}</div>
                  <div class="center order_list_item">￥{{ item.order_actual_price }}</div>
                </div>
              </div>
              <!-- 操作 -->
              <div class="fc jc ac fg fs operating pl10 pr10 pt10 pb10">
                <!-- 待审核订单 -->
                <template v-if="item.platform_sale_check_state !== '1' || item.contract_check_state !== '1'">
                  <p class="mt10 grey cursor" v-if="hasPermission(897)" @click="cancelOrder(item.order_id)">取消订单</p>
                </template>
                <!-- 待确定订单 -->
                <!--                <p class="blue cursor" @click="go(`/servicedetail?id=${item.order_id}`)">确认订单</p>-->
                <!-- 待确定订单 -->
                <template v-if="item.technician_assign_state === '1' && item.assessment_state === '0'">
                  <p class="blue cursor" v-if="hasPermission(898)" @click="go(`/serviceassents?id=${item.order_id}`)">
                    立即评价</p>
                </template>
                <p class="mt10 cursor grey" v-if="hasPermission(896)" @click="go(`/servicedetail?id=${item.order_id}`)">
                  查看详情</p>
              </div>
            </div>
          </div>
        </div>
        <div class="fr ac jc">
          <el-pagination
              :hide-on-single-page="true"
              class="mt20 mb20"
              layout="prev, pager, next"
              :current-page.sync="page"
              :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <apply-for-service v-model="applyShow" @success="getServiceOrders"/>
  </div>
</template>

<script>

import applyForService from "./components/applyForService";

// type == "sales" 为销售订单 else 客户订单
export default {
  data() {
    return {
      // type: this.$route.query.type,
      tab: "",
      order_state: "",
      page: 1,
      total: 0,
      service_list: [],
      applyShow: false
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  watch: {
    page(n) {
      this.getServiceOrders();
    },
    tab(n) {
      if (n == 0) {
        this.order_state = "";
      } else if (n == 1) {
        this.order_state = "1,2";
      } else {
        this.order_state = n;
      }
      this.getServiceOrders();
    },
  },

  methods: {
    // 客户-取消订单
    cancelOrder(id) {
      this.$confirm("是否取消该订单？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.post("serviceInterfaces/v1.0/cancelOrder", {
              order_id: id,
            }).then((res) => {
              this.$message({
                type: "success",
                message: "已取消!",
              });
              this.getServiceOrders();
            });
          })
          .catch(() => {
          });
    },
    // 客户-获取订单列表
    getServiceOrders() {
      let obj = {
        assessment_state: "",
        company_check_state: "",
        technician_assign_state: "",
        pay_state: "",
        contract_check_state: "",
        platform_sale_check_state: "",
      };
      switch (this.tab) {
        case '0':
          obj = {
            assessment_state: "",
            company_check_state: "",
            technician_assign_state: "",
            pay_state: "",
            contract_check_state: "",
            platform_sale_check_state: "",
          };

          break;
        case '1':
          obj = {
            assessment_state: "",
            company_check_state: "1",
            technician_assign_state: "",
            pay_state: "",
            contract_check_state: "0",
            platform_sale_check_state: "0",
          };

          break;
        case '2':
          obj = {
            assessment_state: "",
            company_check_state: "1",
            technician_assign_state: "",
            pay_state: "0",
            contract_check_state: "1",
            platform_sale_check_state: "1",
          };
          break;
        case '3':
          obj = {
            assessment_state: "",
            company_check_state: "1",
            technician_assign_state: "0",
            pay_state: "",
            contract_check_state: "1",
            platform_sale_check_state: "1",
          };

          break;
        case '4':
          obj = {
            assessment_state: "",
            company_check_state: "1",
            technician_assign_state: "1",
            pay_state: "",
            contract_check_state: "1",
            platform_sale_check_state: "1",
          };

          break;
        case '5':
          obj = {
            assessment_state: "1",
            company_check_state: "1",
            technician_assign_state: "1",
            pay_state: "",
            contract_check_state: "1",
            platform_sale_check_state: "1",
          };
          break;
        default:
          break;
      }
      obj.page = this.page;
      this.post("serviceInterfaces/v1.0/getServiceOrders", obj).then((res) => {
        this.total = res.total;
        this.service_list = res.data;
      });
    },
  },
  components: {applyForService},
  filters: {
    order_state(v) {
      switch (v) {
        case "0":
          return "用户取消";
          break;

        case "1":
        case "2":
          return "待确认";
          break;
          break;
        case "3":
          return "待付款";
          break;
        case "4":
          return "待指派";
        case "5":
          return "待评价";
        case "6":
          return "已完成";
          break;
        default:
          return "错误";
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.service {
  .info_box {
    background-color: #fff;

    .order_list_item {
      &:nth-of-type(1) {
        width: 260px;
      }

      width: 175px;
    }

    .order-list {
      .order-item {
        border: 1px solid #e5e5e5;

        .order_list_item {
          border-right: 1px solid #e5e5e5;

          &:nth-of-type(4) {
            border-right: none;
          }
        }

        .top {
          background-color: #f0f6ff;
          padding: 14px;
        }

        .middle {
          .order {
            .order_left {
              min-height: 80px;
              border-right: 1px solid #e5e5e5;
              border-bottom: 1px solid #e5e5e5;

              &:last-child {
                border-bottom: none;
              }

              .goods_img {
                width: 80px;
                height: 80px;
              }
            }

            .operating {
              .el-button {
                font-weight: normal;
              }

              p {
                margin-top: 10px;

                &:nth-of-type(1) {
                  margin-top: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/serviceOrder/index.vue